import * as types from '../constants';

export const initialLeftMenuState = {
  highlight: '',
};

export default (state = initialLeftMenuState, action) => {
  switch (action?.type) {
    case types.HIGHLIGHT_LEFT_MENU:
      return {
        ...state,
        highlight: action.key,
      };
    default:
      return state;
  }
};
